import classNames from 'classnames';
import type { ReactElement } from 'react';
import type { CookieSettingsProps } from './CookieSettings.data';
import styles from './CookieSettings.module.scss';
import PrimaryLink from '../../atoms/primary-link/PrimaryLink';

export default function CookieSettings(_props: CookieSettingsProps): ReactElement {
  return (
    <div className={classNames(styles.cookieSettings)}>
      {/* <!--OneTrust Cookies Settings button start --> */}
      <PrimaryLink
        className={classNames(styles.button, 'ot-sdk-show-settings', 'link-underline-decoration')}
        type="button"
        label="Cookie Settings"
        id="ot-sdk-btn"
      />
      {/* <!--OneTrust Cookies Settings button end --> */}
    </div>
  );
}
